import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { FaArrowLeftLong } from "react-icons/fa6";

import FormInput from "../../../components/common/FormInput/FormInput";
import UploadImage from "../../../components/common/UploadImage/UplaodImage";
import Button from "../../../components/common/Button/Button";

import { getProductTypeById, updateProduct} from "../../../api/service/products.service";
import { showToast } from "../../../components/common/ToastNotification/ToastNotification";
import Loader from "../../../components/Loader/Loader";

const UpdateProductType = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [existingImage, setExistingImage] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);

  const [formData, setFormData] = useState({
    category_id: "",
    title: "",
    sub_title: "",
    slug: "",
    text: "",
    application_of_use: "",
  });

  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(true);

  useEffect(() => {
    const fetchProductType = async () => {
      try {
        setFetching(true);
        const response = await getProductTypeById(id);
        
        // console.log("Full API Response:", response);

        const productData = response?.data?.success ? response.data.data : response?.data;

        // console.log("Extracted Product Data:", productData);

        if (productData) {
          setFormData({
            category_id: productData.category_id || "",
            title: productData.title || "",
            sub_title: productData.sub_title || "",
            slug: productData.slug || "",
            text: productData.text || "",
            application_of_use: productData.application_of_use || "",
          });

     
          
     
          setExistingImage("");
        } else {
          showToast.error("Product data not found");
        }
      } catch (error) {
        console.error("Fetch Error:", error);
        showToast.error("Failed to load product type details.");
      } finally {
        setFetching(false);
      }
    };

    if (id) fetchProductType();
  }, [id]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (file) => {
    setSelectedFile(file);
    console.log("Selected file:", file);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.title.trim()) {
      showToast.error("Title is required");
      return;
    }
    if (!formData.sub_title.trim()) {
      showToast.error("Sub Title is required");
      return;
    }
    if (!formData.text.trim()) {
      showToast.error("Description is required");
      return;
    }
    if (!formData.application_of_use.trim()) {
      showToast.error("Application of Use is required");
      return;
    }

    try {
      setLoading(true);

      const submitData = new FormData();
      submitData.append("category_id", formData.category_id);
      submitData.append("product_id", id);
      submitData.append("title", formData.title.trim());
      submitData.append("sub_title", formData.sub_title.trim());
      submitData.append("text", formData.text.trim());
      submitData.append("application_of_use", formData.application_of_use.trim());
      

      if (formData.slug) {
        submitData.append("slug", formData.slug.trim());
      }

    
      if (selectedFile) {
        submitData.append("image", selectedFile);
      }

      // console.log("Submitting data for ID:", id);

      const response = await updateProduct(submitData);
      
      // console.log("Update response:", response);

      if (response?.data?.success) {
        showToast.success(response.data.message || "Product type updated successfully!");
        setTimeout(() => navigate(-1), 1200);
      } else {
        showToast.error(response?.data?.message || "Failed to update product");
      }
    } catch (error) {
      console.error("Update Error:", error);
      showToast.error(error?.response?.data?.message || "Failed to update product");
    } finally {
      setLoading(false);
    }
  };

  if (fetching) {
    return (
      <>
        <Loader />
      </>
    );
  }

  return (
    <>
      <div className="d-flex align-items-center gap-2 mb-3">
        <FaArrowLeftLong style={{ cursor: "pointer" }} onClick={() => navigate(-1)} />
        <h3 className="mb-0 management-tile ml-2">Update Product</h3>
      </div>

      <form onSubmit={handleSubmit}>
        <Row>
          <Col xl={6} lg={6} sm={12} className="mb-3">
            <label className="form-label">Title *</label>
            <FormInput
              name="title"
              value={formData.title}
              onChange={handleInputChange}
              placeholder="Enter title"
              required
            />
          </Col>

          <Col xl={6} lg={6} sm={12} className="mb-3">
            <label className="form-label">Sub Title *</label>
            <FormInput
              name="sub_title"
              value={formData.sub_title}
              onChange={handleInputChange}
              placeholder="Enter sub title"
              required
            />
          </Col>

          <Col xl={6} lg={6} sm={12} className="mb-3">
            <label className="form-label">Slug</label>
            <FormInput
              name="slug"
              value={formData.slug}
              onChange={handleInputChange}
              placeholder="Enter slug"
            />
          </Col>

          <Col xs={12} className="mb-3">
            <label className="form-label">
              Description <span className="text-danger">*</span>
            </label>
            <FormInput
              type="textarea"
              name="text"
              value={formData.text}
              onChange={handleInputChange}
              placeholder="Enter product description"
              required
            />
          </Col>

          <Col xs={12} className="mb-3">
            <label className="form-label">Application of Use *</label>
            <FormInput
              type="textarea"
              name="application_of_use"
              value={formData.application_of_use}
              onChange={handleInputChange}
              placeholder="Enter application of use"
              required
            />
          </Col>

          {/* <Col xs={12} className="mb-3">
            <label className="form-label">Product Image</label>
            
        
            {existingImage && !selectedFile && (
              <div className="mb-2">
                <p className="text-muted small">Current Image:</p>
                <img 
                  src={existingImage} 
                  alt="Current product" 
                  style={{ 
                    maxWidth: "200px", 
                    maxHeight: "200px", 
                    objectFit: "contain",
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                    padding: "4px"
                  }} 
                />
              </div>
            )}
            
            <UploadImage
              onFileSelect={handleFileChange}
              multiple={false}
            />
            
            {selectedFile && (
              <p className="text-success small mt-2">
                New image selected: {selectedFile.name}
              </p>
            )}
          </Col> */}

          <Col xs={12}>
            <Button type="submit" disabled={loading}>
              {loading ? "Updating..." : "Update Product"}
            </Button>
          </Col>
        </Row>
      </form>
    </>
  );
};

export default UpdateProductType;